import React from 'react';
import { Navigate } from 'react-router-dom';
import { User } from '../types';
import { getDefaultModulePath, hasModuleAccess, isGuidedSupervisor } from '../utils/modulePermissions';

/** Covers old bookmarks and sessions restored directly on the dashboard. */
export function DashboardEntryRoute({ user, children }: { user: User | null; children: React.ReactNode }) {
  if (isGuidedSupervisor(user) || !hasModuleAccess(user, 'dashboard')) {
    return <Navigate to={getDefaultModulePath(user)} replace />;
  }
  return <>{children}</>;
}
